
//API serivice FUNCTIONS
import { current } from "@reduxjs/toolkit";
import { filterByChoice, getFromLocalStorage, lengthChecker, setToLocalStorage } from "../../Helpers/helpers";
import { changeHall, changeLine, changeMachine, changePlant, changePlants, changeShift, setCurrentPlant, setPlantsList } from "../../Redux/features/plant.slice";
import { setLoader, setPageLoader } from "../../Redux/features/utils.slice";
import { login } from "../../Redux/features/auth.slice";
import { getRequest, postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
import { error, info, success } from "../../Helpers/notification";
import { getRolesList } from "./roles.api";
import moment from "moment";
const { auditTrails } = apiRoutes;


const generateReport = async (current, dispatch, setLogs) => {
    dispatch(setPageLoader({ page: 'auditTrails', flag: true }))
    let { plant = null,
        hall = null,
        line = null,
        shift = null,
        reason = null,
        start = new Date(),
        end = new Date() } = current;
    //Getting Production Lines by Plant ID
    start = moment(start).format()
    start = (start)?.toString()?.split('+')[0] + '.000Z'
    end = moment(end).format()
    end = (end)?.toString()?.split('+')[0] + '.000Z'
    let query = { plantId: { $in: [plant] }, time: { $gte: start, $lte: end } }
    if (line !== 'All')
        query = { ...query, lineId: line }
    if (hall !== 'All Halls')
        query = { ...query, hallName: hall }
    if (shift !== 'All Shifts' && shift !== 'All' && shift !== null)
        query = { ...query, shiftName: shift }
    if (reason !== 1 && reason !== 'All Reasons')
        query = { ...query, action: reason }
    let res = await postRequest({
        endPoint: auditTrails.generateReport,
        body: { conditions: query }
    })

    console.log('res', res)
    if (!res?.success) {
        error(res?.message)
        return dispatch(setPageLoader({ page: 'auditTrails', flag: false }))
    }
    if (!res?.response?.length)
        info('No data available in logs to display.')
    let logs = res?.response?.map((log, i) => ({ ...log, key: i + 1 }))
    setLogs(logs || [])
    return dispatch(setPageLoader({ page: 'auditTrails', flag: false }))

}



export {
    generateReport
}
